import { create } from 'zustand';

export interface CompaniesStore {
  isDoeePayoutSetupNeededToPublish: boolean;
  setIsDoeePayoutSetupNeededToPublish: (id: boolean) => void;
  isPricingPolicyRuleNeededToPublish: boolean;
  setIsPricingPolicyRuleNeededToPublish: (id: boolean) => void;
}

export const useCompaniesStore = create<CompaniesStore>((set) => ({
  isPricingPolicyRuleNeededToPublish: false,
  isDoeePayoutSetupNeededToPublish: false,
  setIsDoeePayoutSetupNeededToPublish: (isNeeded: boolean) =>
    set(() => ({ isDoeePayoutSetupNeededToPublish: isNeeded })),
  setIsPricingPolicyRuleNeededToPublish: (isNeeded: boolean) =>
    set(() => ({ isPricingPolicyRuleNeededToPublish: isNeeded })),
}));
